import React from 'react';
import { Menu, X } from 'lucide-react';

export default function Navbar({
    t,
    scrolled,
    scrollToSection,
    isMobileMenuOpen,
    setIsMobileMenuOpen,
    portfolio,
    currentLang,
    changeLang
}) {
    return (
        <>
            <nav className={`fixed w-full z-50 transition-all duration-300 ${scrolled ? 'bg-slate-900/95 backdrop-blur-md shadow-lg py-2' : 'bg-slate-900 py-4'}`}>
                <div className="max-w-7xl mx-auto px-4 md:px-8">
                    <div className="flex justify-between items-center h-16">
                        <div
                            onClick={() => scrollToSection(t.nav[0].toLowerCase().replace(/\s+/g, '-'))}
                            className="text-2xl font-black bg-gradient-to-r from-cyan-400 to-blue-600 bg-clip-text text-transparent hover:scale-105 transition-transform cursor-pointer"
                        >
                            {portfolio.personal.name ? portfolio.personal.name.split(' ').map(n => n[0]).join('') : 'JD'}
                        </div>

                        {/* Desktop Menu */}
                        <div className="hidden md:flex space-x-8">
                            {t.nav.map((item, idx) => (
                                <button
                                    key={idx}
                                    onClick={() => scrollToSection(item.toLowerCase().replace(/\s+/g, '-'))}
                                    className="relative group text-slate-100 font-medium hover:text-white transition-colors duration-300 py-2"
                                >
                                    {item}
                                    <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-cyan-400 group-hover:w-full transition-all duration-300"></span>
                                </button>
                            ))}
                        </div>

                        <div className="flex items-center gap-4">
                            {/* Language Selector Dropdown */}
                            <div className="relative group">
                                <button className="flex items-center gap-2 bg-slate-800/90 backdrop-blur-md px-3 py-2 rounded-full border border-slate-700 hover:border-cyan-500 shadow-lg transition-all duration-300" aria-label="Alternar Idioma">
                                    <span className="text-xl">
                                        {currentLang === 'es' ? '🇪🇸' : currentLang === 'pt' ? '🇵🇹' : '🇺🇸'}
                                    </span>
                                    <span className="font-bold text-white uppercase text-sm">{currentLang}</span>
                                </button>

                                <div className="absolute top-full right-0 mt-2 w-32 bg-slate-800 rounded-xl shadow-xl border border-slate-700 overflow-hidden opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 transform origin-top-right">
                                    {[
                                        { code: 'es', flag: '🇪🇸', name: 'Español' },
                                        { code: 'pt', flag: '🇵🇹', name: 'Português' },
                                        { code: 'en', flag: '🇺🇸', name: 'English' }
                                    ].map((lang) => (
                                        <button
                                            key={lang.code}
                                            onClick={() => changeLang(lang.code)}
                                            className={`w-full px-4 py-3 flex items-center gap-3 hover:bg-slate-700 transition-colors ${currentLang === lang.code ? 'bg-slate-700/50 text-cyan-400' : 'text-slate-300'
                                                }`}
                                        >
                                            <span className="text-xl">{lang.flag}</span>
                                            <span className="text-sm font-medium">{lang.name}</span>
                                        </button>
                                    ))}
                                </div>
                            </div>

                            {/* Mobile Menu Button */}
                            <button
                                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                                className="md:hidden text-slate-300 hover:text-white transition-colors p-2"
                                aria-label="Toggle menu"
                            >
                                {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
                            </button>
                        </div>
                    </div>

                    {/* Mobile Menu */}
                    {isMobileMenuOpen && (
                        <div className="md:hidden fixed top-16 left-0 w-full h-[calc(100vh-4rem)] bg-slate-900/98 backdrop-blur-md shadow-2xl border-t border-slate-800 animate-fade-in-up overflow-y-auto">
                            <div className="px-4 py-6 space-y-4">
                                {t.nav.map((item, idx) => (
                                    <button
                                        key={idx}
                                        onClick={() => {
                                            scrollToSection(item.toLowerCase().replace(/\s+/g, '-'));
                                            setIsMobileMenuOpen(false);
                                        }}
                                        className="block w-full text-left text-lg text-slate-100 font-medium hover:text-cyan-400 hover:bg-slate-800/50 px-4 py-3 rounded-lg transition-all duration-300"
                                    >
                                        {item}
                                    </button>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </nav>


        </>
    );
}
